module.exports = __webpack_public_path__ + "static/logo-ed24646a45e367d16d342b0bcceddad4.png";